<script setup>
/* eslint-disable */

import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useRacingSportsStore } from '@/stores/racing_sports';
import { usePreSportsStore } from '@/stores/pre_sports';

const router = useRouter();
const racingSportsStore = useRacingSportsStore();
const preSportsStore = usePreSportsStore();

const selectSport = (sport_id) => {
	router.push({name: 'racing-coupons', params: {sport_id: sport_id}});
	racingSportsStore.setSelectedRacingSportId(sport_id);
}
</script>

<template>
	<div class="slider-tab-main">
		<div v-for="sport in racingSportsStore.racingSports" :key="sport.id" class="slider-item" :class="{'active': racingSportsStore.selectedRacingSportId == sport.id }">
			<div @click="selectSport(sport.id)" class="slider-content">
				<svg  class="normal-img"
					xmlns="http://www.w3.org/2000/svg"
					xml:space="preserve"
					version="1.1"
					style="width:23px; fill: none; stroke: var(--tab-text-color-hover); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
					viewBox="0 0 30 25"
					xmlns:xlink="http://www.w3.org/1999/xlink">
					<use :xlink:href="preSportsStore.preSportWhiteIcon(sport.id) + '#svg3108'" stroke-width="1px"  />
				</svg>

				<!-- <img :src="preSportsStore.preSportWhiteIcon(sport.id)" alt=""> -->
				<p>{{ sport.name }}</p>
			</div>
		</div>
	</div>
</template>
<style scoped>
.slider-tab-main .slider-item.active p {
	color: var(--tab-text-color-hover) !important;
}
</style>